import React, { useEffect } from 'react';
import OldUI from './new';
import NewUI from './new-ui';
import ScanUI from './scan-ui';
import { isFromPcHome, isOnlyShowScanUI, isTeamSubscription } from '@/constants';
import { getIncomeSource } from '@/utils/vip';
import { getUrlParam } from '@/utils';
import classNames from 'classnames';
import Loading from '@/components/loading';
import { useAtom } from 'jotai';
import {
  isFromZhankuAtom,
  isInitAtom,
  isViewNewUiAtom,
  taskIdAtom,
  teamInfoAtom,
  userInfoAtom,
  ZhankuManagerInfoAtom,
  curTabAtom,
  extraTrackDataAtom,
  extraTransferDataAtom,
} from '@/store';
import { initPage } from '@/utils/common';
import { useLocaleStore } from '@/i18n/localeStore';
import { TabType } from '@/constants/subscription';

import styles from './index.module.css';

// PC内嵌高级会员紫金色
const ZIJIN_THEME_CLASS = 'theme-zijin';
// 团队版蓝色
const TEAM_THEME_CLASS = 'theme-team-blue';
export interface TrackData {
  event_id: string;
  event_name?: string; // pc客户端埋点需要
  params: {
    [key: string]: any;
  };
}

const Subscription: React.FC = () => {
  const { $t } = useLocaleStore();
  const [isInit] = useAtom(isInitAtom);
  const [teamInfo] = useAtom(teamInfoAtom);
  const [isViewNewUi] = useAtom(isViewNewUiAtom);
  const [isFromZhanku] = useAtom(isFromZhankuAtom);
  const [zhankuManagerInfo] = useAtom(ZhankuManagerInfoAtom);
  const [userInfo] = useAtom(userInfoAtom);
  const [, setTaskId] = useAtom(taskIdAtom);
  const [curTab] = useAtom(curTabAtom);
  const [, setExtraTrackData] = useAtom(extraTrackDataAtom);
  const [, setExtraTransferData] = useAtom(extraTransferDataAtom);
  useEffect(() => {
    const messageHandler = (e: MessageEvent) => {
      let data:
        | {
            action?: string;
            data?: {
              task_id?: string;
              transfer_data?: Record<string, any>;
              track_data?: Record<string, any>;
            };
          }
        | string =
        e.data || (e as MessageEvent & { originalEvent?: MessageEvent }).originalEvent?.data;
      if (typeof data === 'string' && /^[\[\{]/.test(data)) {
        data = JSON.parse(data);
      }

      if (data && typeof data === 'object' && data.action === 'setMessageData' && data.data) {
        const taskId =
          data.data?.task_id
            ?.split(',')
            .map((item) => item.trim().replace(/^co_/, ''))
            .join(',') || '';
        setTaskId(taskId);
        setExtraTransferData(data.data?.transfer_data || {});
        setExtraTrackData(data.data?.track_data || {});
      }
    };

    console.log('messageHandler===========1');
    window.addEventListener('message', messageHandler, false);
    return () => {
      window.removeEventListener('message', messageHandler, false);
    };
  }, []);

  useEffect(() => {
    initPage();
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    const enabled = isFromPcHome && curTab === TabType.PRO_SUB;
    // PC内嵌高级会员紫金色
    root.classList.toggle(ZIJIN_THEME_CLASS, enabled);
    // 团队版会员/美豆蓝色
    root.classList.toggle(
      TEAM_THEME_CLASS,
      !!isTeamSubscription && [TabType.SUB, TabType.MEIDOU].includes(curTab)
    );
    return () => {
      root.classList.remove(ZIJIN_THEME_CLASS);
      root.classList.remove(TEAM_THEME_CLASS);
    };
  }, [curTab]);

  // pc订阅中，支持pc端登录操作
  const isPcLogin =
    getIncomeSource() !== 'MTXX-WEB' && getUrlParam('client_referer') === 'client_login';

  // 海洛客户，阻断提示
  if (isFromZhanku) {
    return (
      <div className={classNames(styles.main, styles.block)}>
        {$t((v, { r }) =>
          r(v.Text_InsufficientBenefits, [zhankuManagerInfo?.manager, zhankuManagerInfo?.phone])
        )}
      </div>
    );
  }

  // 企业版/来自服务市场用户，不允许线上购买
  if (teamInfo?.type === 2 || userInfo?.ban_purchase) {
    return (
      <div className={classNames(styles.main, styles.block)}>
        {$t((v) => v.Text_OnlinePurchaseDisabled)}
      </div>
    );
  }

  return (
    <>
      {isInit && !isPcLogin ? (
        isOnlyShowScanUI ? (
          <ScanUI />
        ) : isViewNewUi ? (
          <NewUI />
        ) : (
          <OldUI />
        )
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Subscription;
